// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.device-page {
  width: min(100%, 1200px);
  padding: 0 1rem 3rem;
}

.device-page.section {
  margin-top: 0.75rem;
}

.device-filters {
  display: grid;
  grid-template-columns: minmax(14rem, 2fr) repeat(2, minmax(11rem, 1fr)) auto;
  gap: 1rem;
  align-items: end;
}

.device-result-count {
  color: #5b6570;
}

.device-pagination {
  justify-content: center;
  margin: 1.5rem 0;
}

.device-table th {
  white-space: nowrap;
}

.device-detail-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.device-detail-heading h1 {
  margin-bottom: 0.25rem;
  font-size: var(--title-2-tablet-size);
}

.device-detail-card th {
  width: 42%;
  color: var(--secondary-color);
  font-weight: 600;
}

.device-detail-card td {
  overflow-wrap: anywhere;
}

@media (max-width: 576px) {
  .device-filters {
    grid-template-columns: 1fr;
  }

  .device-detail-heading {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/DeviceList/DevicePages.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4EAA4E;EAC5E,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".device-page {\n  width: min(100%, 1200px);\n  padding: 0 1rem 3rem;\n}\n\n.device-page.section {\n  margin-top: 0.75rem;\n}\n\n.device-filters {\n  display: grid;\n  grid-template-columns: minmax(14rem, 2fr) repeat(2, minmax(11rem, 1fr)) auto;\n  gap: 1rem;\n  align-items: end;\n}\n\n.device-result-count {\n  color: #5b6570;\n}\n\n.device-pagination {\n  justify-content: center;\n  margin: 1.5rem 0;\n}\n\n.device-table th {\n  white-space: nowrap;\n}\n\n.device-detail-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.device-detail-heading h1 {\n  margin-bottom: 0.25rem;\n  font-size: var(--title-2-tablet-size);\n}\n\n.device-detail-card th {\n  width: 42%;\n  color: var(--secondary-color);\n  font-weight: 600;\n}\n\n.device-detail-card td {\n  overflow-wrap: anywhere;\n}\n\n@media (max-width: 576px) {\n  .device-filters {\n    grid-template-columns: 1fr;\n  }\n\n  .device-detail-heading {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
